import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

// Modals
import PayNowModal from "../popupmodels/PayNowModal";
import PaymentUploadDocumentModal from "../popupmodels/PaymentUploadDocumentModal";
import PaymentSuccessModal from "../popupmodels/PaymentSuccessModal";
import PaymentFailureModal from "../popupmodels/PaymentFailureModal";

// Styles & Images
import "../../assets/styles/LandingHeroSection.css";
import LaptopBackground from "../../assets/images/HeroBack1.svg";
import WhoShouldEnroll from "./WhoShouldEnroll";
import HowItWorks from "./HowItWorks";
import PoweredBy from "./PoweredBy";
import LandingFooter from "../footer/LandingFooter";
import Timer from "./Timer";
import LandingCTA from "./LandingCTA";
import LandingPath from "./LandingPath";
import LandingHeader from "../header/LandingHeader";
import LandingFAQ from "./LandingFAQ";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import AnimatedText from "./AnimatedText";
import StepThree from "./StepThree";
import LandingInternship from "./LandingInternship";

const baseUrl = "https://prodapi.ariseforyou.com/api";

const LandingPage = ({ formRef }) => {
    const navigate = useNavigate();




    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        partnerCode: "",
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [studentId, setStudentId] = useState(null);

    // Payment modals
    const [activeModalQRCode, setActiveModalQRCode] = useState(false);
    const [activeModalUploadDocument, setActiveModalUploadDocument] = useState(false);
    const [activeModalSuccess, setActiveModalSuccess] = useState(false);
    const [activeModalFailure, setActiveModalFailure] = useState(false);

    const partnerOptions = [
        { value: "Social media", label: "Social media" },
        { value: "Search Engine", label: "Search Engine" },
        { value: "A4UPEA", label: "A4UPEA" },
        { value: "A4UETR", label: "A4UETR" },
        { value: "A4UTPD", label: "A4UTPD" },
        { value: "A4UTPO", label: "A4UTPO" },
        { value: "A4UMSH", label: "A4UMSH" },
        { value: "A4UICT", label: "A4UICT" },
        { value: "A4UTCT", label: "A4UTCT" },
        { value: "Others", label: "Others" },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (/^\d{0,10}$/.test(value)) {
                setFormData((prev) => ({ ...prev, [name]: value }));
            }
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const validateForm = () => {
        const tempErrors = {};
        if (!formData.name) tempErrors.name = "Name is required";
        if (!formData.phone || !/^\d{10}$/.test(formData.phone))
            tempErrors.phone = "Enter valid 10-digit phone number";
        if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email))
            tempErrors.email = "Enter valid email";
        if (!formData.partnerCode) tempErrors.partnerCode = "Partner code is required";
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.error("Please fix errors before submitting.");
            return;
        }
        setLoading(true);
        try {
            const payload = {
                name: formData.name,
                phone_number: formData.phone,
                email: formData.email,
                partner_code: formData.partnerCode,
            };
            const response = await axios.post(`${baseUrl}/student/register`, payload);
            if (response.data.success) {
                setStudentId(response.data.result?.student_id);
                localStorage.setItem("registerId", response.data.result?.student_id);
                setActiveModalQRCode(true);
                setFormData({ name: "", phone: "", email: "", partnerCode: "" });
            } else {
                toast.error(response.data.message || "Something went wrong.");
            }
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || "Failed to submit the form.");
        } finally {
            setLoading(false);
        }
    };

    const handleQRCodeSubmit = () => {
        setActiveModalQRCode(false);
        setActiveModalUploadDocument(true);
    };

    const handleUploadDocumentSubmit = async (file) => {
        const payloadData = {
            id: localStorage.getItem("registerId"),
            payment_status: "success",
            amount: 2990,
            payment_screenshot: file,
        };
        try {
            const response = await axios.post(`${baseUrl}/payment`, payloadData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            if (response.data.success) {
                setActiveModalUploadDocument(false);
                setActiveModalSuccess(true);
                localStorage.removeItem("registerId");
                toast.success("Payment Screenshot Uploaded successfully!");
            } else {
                setActiveModalUploadDocument(false);
                setActiveModalFailure(true);
                toast.error(response.data?.error || "Failed to upload the Payment Screenshot!");
            }
        } catch (error) {
            console.error("Error Upload Payment:", error);
            setActiveModalUploadDocument(false);
            setActiveModalFailure(true);
            toast.error("Maximum 5 MB allowed. Failed to upload Payment Screenshot!");
        }
    };

    const handleSuccessSubmit = () => setActiveModalSuccess(false);
    const handleFailureSubmit = () => {
        setActiveModalFailure(false);
        setActiveModalUploadDocument(true);
    };

    return (
        <>
            <ToastContainer />


            {/* Hero Section */}
            <section className="landing-hero-section">
                {/* Left Side */}
                <div
                    className="landing-hero-left"
                    style={{ backgroundImage: `url(${LaptopBackground})` }}
                >
                    <div className="landing-hero-overlay"></div>
                    <div className="landing-hero-content">
                        <p>From now to next</p>
                        <h3>ARISE FOR YOU™ </h3>
                        <p className="landing-hero-singleline">The journey starts here</p>
                        <p className="landing-hero-subline">This is what you get </p>

                        <div>
                            <AnimatedText />
                        </div>
                    </div>

                </div>

                {/* Right Side */}
                <div className="landing-hero-right" ref={formRef}>
                    <div className="landing-form-card">
                        <h2>Join India’s Biggest Student Entrepreneurship Challenge</h2>
                        <p>Complete this quick form to get started.</p>
                        <form onSubmit={handleSubmit}>
                            {/* React Inputs */}
                            {/* <input
                                type="text"
                                name="name"
                                placeholder="Your Name"
                                value={formData.name}
                                onChange={handleChange}
                                className="landing-input"
                            />
                            {errors.name && <small className="landing-hero-error-text">{errors.name}</small>}


                            <input
                                type="text"
                                name="phone"
                                placeholder="Mobile Number"
                                value={formData.phone}
                                maxLength={10}
                                onChange={handleChange}
                                className="landing-input"
                            />
                            {errors.phone && <small className="landing-hero-error-text">{errors.phone}</small>}

                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                                className="landing-input"
                            />
                            {errors.email && <small className="landing-hero-error-text">{errors.email}</small>}

                            <Select
                                options={partnerOptions}
                                value={partnerOptions.find((option) => option.value === formData.partnerCode)}
                                onChange={(selected) =>
                                    setFormData((prev) => ({ ...prev, partnerCode: selected.value }))
                                }
                                placeholder="Select code shared by your college or partner (if any)"
                                classNamePrefix="landing-dropdown"
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        minHeight: '40px',
                                        borderRadius: '8px',
                                        border: '1px solid #ddd',
                                        backgroundColor: '#f7f8fa',
                                        // padding: '0 0px',
                                    }),
                                    valueContainer: (provided) => ({
                                        ...provided,
                                        // Ensure consistent height and vertical centering
                                        height: '44px', // Set a fixed height
                                        padding: '0 12px',
                                        display: 'flex',
                                        alignItems: 'center', // Center content vertically
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: '#999',
                                        // The valueContainer will handle vertical centering
                                        margin: 0, // Remove default margins

                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        // The valueContainer will handle vertical centering
                                        margin: 0, // Remove default margins
                                    }),
                                    indicatorsContainer: (provided) => ({
                                        ...provided,
                                        height: '44px', // Ensure indicators container matches control height
                                        display: 'flex',
                                        alignItems: 'center', // Center arrow vertically
                                    }),
                                    dropdownIndicator: (provided) => ({
                                        ...provided,
                                        padding: '0 8px',
                                        color: '#999',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        borderRadius: '8px',
                                        overflow: 'hidden',
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        padding: '10px 12px',
                                        backgroundColor: state.isFocused ? '#f04438' : 'white',
                                        color: state.isFocused ? 'white' : '#000',
                                        cursor: 'pointer',
                                    }),
                                }}
                            />
                            {errors.partnerCode && (
                                <small className="landing-hero-error-text">{errors.partnerCode}</small>
                            )} */}
                            {/* 
                            <button type="submit" disabled={loading} className="mb-0 txt-white font-regular-four txt-size">
                                {loading ? "Submitting..." : "Enroll"}
                            </button> */}
 <div className="enroll-btn-container">
    <button
      type="button"
      disabled={loading}
      className="enroll-btn mb-0 txt-white font-regular-four txt-size"
      onClick={() => window.open("https://ariseforyou.com/register", "_blank")}
    >
      {loading ? "Loading..." : "Enroll Now"}
    </button>
  </div>

                            <p>Join a community of over 1000 aspiring entrepreneurs.</p>
                        </form>
                    </div>
                </div>
            </section>

            {/* Payment Modals */}
            {activeModalQRCode && (
                <PayNowModal
                    id="modal-qrcode"
                    show={activeModalQRCode}
                    studentId={studentId}
                    onClose={() => setActiveModalQRCode(false)}
                    onSubmit={handleQRCodeSubmit}
                />
            )}
            {activeModalUploadDocument && (
                <PaymentUploadDocumentModal
                    id="modal-upload"
                    show={activeModalUploadDocument}
                    onClose={() => setActiveModalUploadDocument(false)}
                    onSubmit={handleUploadDocumentSubmit}
                />
            )}
            {activeModalSuccess && (
                <PaymentSuccessModal
                    id="modal-success"
                    show={activeModalSuccess}
                    onClose={() => setActiveModalSuccess(false)}
                    onSubmit={handleSuccessSubmit}
                />
            )}
            {activeModalFailure && (
                <PaymentFailureModal
                    id="modal-failure"
                    show={activeModalFailure}
                    onClose={() => setActiveModalFailure(false)}
                    onSubmit={handleFailureSubmit}
                />
            )}



        </>
    );
};

export default LandingPage;
